<div
  class="alert center-block row text-left animated fadeIn fast"
  role="alert"
  [ngClass]="{
    'alert-warning': alert.type === 'warning',
    'alert-danger': alert.type === 'danger',
    'width-auto': alert.width === 'auto'
  }"
>
  <div class="text-left icon-alert">
    <img *ngIf="alert.type === 'warning'" src="assets/images/login/icn-alert-warning.png" alt="Alerta" />
    <img *ngIf="alert.type === 'danger'" src="assets/images/login/icn-alert-danger.png" alt="Alerta" />
  </div>
  <h5 class="span-alert">
    {{ alert.message }}
  </h5>
</div>
